export const listMock = [
  {
    id: 'PESS1777960',
    select: false,
    user: {
      corretor: 'Bart',
      super: 'Cabo',
      image: 'bart'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'cabo@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '2',
    select: false,
    user: {
      corretor: 'Manjula',
      super: 'Apu',
      image: 'manjula'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'apu@simpson.com',
    creci:{
      status: 'expired',
      expiration: '31/12/2019',
    },
    market: 'Secundário (Venda/locação)',
  },
  {
    id: '3',
    select: false,
    user: {
      corretor: 'Burns',
      super: 'Burns',
      image: 'burn'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'burn@simpson.com',
    creci:{
      status: null,
    },
    market: 'Primário e Secundário (Venda/locação)',
  },
  {
    id: '4',
    select: false,
    user: {
      corretor: 'Otto',
      super: 'Otto',
      image: 'otto'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'otto@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: '',
  },
  {
    id: '5',
    select: false,
    user: {
      corretor: 'Krusty',
      super: 'Krusty Super',
      image: 'krusty'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'krusty@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '6',
    select: false,
    user: {
      corretor: 'Frink',
      super: 'Frink Super',
      image: 'frink'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'frink@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '7',
    select: false,
    user: {
      corretor: 'Homer',
      super: 'Homer Super',
      image: 'home'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'homer@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '8',
    select: false,
    user: {
      corretor: 'Lionel',
      super: 'Lionel Super',
      image: 'lionel'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'lionel@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Secundário (Venda)',
  },
  {
    id: '9',
    select: false,
    user: {
      corretor: 'Moe',
      super: 'Moe Super',
      image: 'mo'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'moe@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Secundário (Locação)',
  },
  {
    id: '10',
    select: false,
    user: {
      corretor: 'Murphy',
      super: 'Murphy Super',
      image: 'sax'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'sax@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Secundário (Venda/locação)',
  },
  {
    id: '11',
    select: false,
    user: {
      corretor: 'Snake',
      super: 'Snake Super',
      image: 'snack'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'snake@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '12',
    select: false,
    user: {
      corretor: 'Troy',
      super: 'Troy Super',
      image: 'troy'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'troy@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '13',
    select: false,
    user: {
      corretor: 'Edna',
      super: 'SEYMOUR',
      image: 'edna'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'edna@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '14',
    select: false,
    user: {
      corretor: 'Selma',
      super: 'Selma Super',
      image: 'selma'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'selma@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '15',
    select: false,
    user: {
      corretor: 'Luann',
      super: 'Kirk',
      image: 'luann'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'luann@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  },
  {
    id: '16',
    select: false,
    user: {
      corretor: 'Rick',
      super: 'Rick Super',
      image: 'rick'
    },
    phone: {
      ddi: '11',
      phone: '1198877-6655'
    },
    email: 'rick@simpson.com',
    creci:{
      status: 'ok',
      expiration: '31/12/2020',
    },
    market: 'Primário',
  }
];

export const listMockParticipants = [
  {
    id: '1',
    select: false,
    user: {
      corretor: 'Bart',
      super: 'Cabo',
      image: 'bart'
    },
    enterprise: 'Lopes'
  },
  {
    id: '2',
    select: false,
    user: {
      corretor: 'Manjula',
      super: 'Apu',
      image: 'manjula'
    },
    enterprise: 'Lopes'
  },
  {
    id: '3',
    select: false,
    user: {
      corretor: 'Burns',
      super: 'Burns',
      image: 'burn'
    },
    enterprise: 'Lopes'
  },
  {
    id: '4',
    select: false,
    user: {
      corretor: 'Otto',
      super: 'Otto',
      image: 'otto'
    },
    enterprise: 'Lopes'
  },
  {
    id: '5',
    select: false,
    user: {
      corretor: 'Krusty',
      super: 'Krusty Super',
      image: 'krusty'
    },
    enterprise: 'Lopes'
  },
  {
    id: '6',
    select: false,
    user: {
      corretor: 'Frink',
      super: 'Frink Super',
      image: 'frink'
    },
    enterprise: 'Lopes'
  },
  {
    id: '7',
    select: false,
    user: {
      corretor: 'Homer',
      super: 'Homer Super',
      image: 'home'
    },
    enterprise: 'Lopes'
  },
  {
    id: '8',
    select: false,
    user: {
      corretor: 'Lionel',
      super: 'Lionel Super',
      image: 'lionel'
    },
    enterprise: 'Lopes'
  },
  {
    id: '9',
    select: false,
    user: {
      corretor: 'Moe',
      super: 'Moe Super',
      image: 'mo'
    },
    enterprise: 'Lopes'
  },
  {
    id: '10',
    select: false,
    user: {
      corretor: 'Murphy',
      super: 'Murphy Super',
      image: 'sax'
    },
    enterprise: 'Lopes'
  },
  {
    id: '11',
    select: false,
    user: {
      corretor: 'Snake',
      super: 'Snake Super',
      image: 'snack'
    },
    enterprise: 'Lopes'
  },
  {
    id: '12',
    select: false,
    user: {
      corretor: 'Troy',
      super: 'Troy Super',
      image: 'troy'
    },
    enterprise: 'Lopes'
  },
  {
    id: '13',
    select: false,
    user: {
      corretor: 'Edna',
      super: 'SEYMOUR',
      image: 'edna'
    },
    enterprise: 'Lopes'
  },
  {
    id: '14',
    select: false,
    user: {
      corretor: 'Selma',
      super: 'Selma Super',
      image: 'selma'
    },
    enterprise: 'Lopes'
  },
  {
    id: '15',
    select: false,
    user: {
      corretor: 'Luann',
      super: 'Kirk',
      image: 'luann'
    },
    enterprise: 'Lopes'
  },
  {
    id: '16',
    select: false,
    user: {
      corretor: 'Rick',
      super: 'Rick Super',
      image: 'rick'
    },
    enterprise: 'Lopes'
  }
];
export const listOptions = [
  {
    id: 1,
    name: 'Editar escala'
  },
  {
    id: 2,
    name: 'Configurar usuário'
  },
  {
    id: 3,
    name: 'Ver filas'
  },
  {
    id: 4,
    name: 'Ver perfil'
  },
  {
    id: 5,
    name: 'Ver facs'
  }
];

export const OPTIONS_TM_ENUM = {
  CONFIG_USER: 'Configurar usuário',
  EDIT_SCALE: 'Editar escala',
  SEE_QUEUE: 'Ver filas',
  SEE_PROFILE: 'Ver perfil',
  SEE_FACS: 'Ver facs'
};